<template>
  <div class="modal fade" id="modal-faqs">
    <div class="modal-dialog modal-dialog-l">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span></button>
          <h4 class="modal-title">{{$t('camps.faqs.title')}}</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-xs-12">
              <div class="box box-solid">
                <div class="box-body">
                  <div class="box-group" id="accordion">
                    <div class="panel box box-primary">
                      <div class="box-header with-border">
                        <h4 class="box-title">
                          <a data-toggle="collapse" data-parent="#accordion" href="#collapseHelp" aria-expanded="false"
                             class="collapsed">
                            {{$t('help.title')}}
                          </a>
                        </h4>
                      </div>
                      <div id="collapseHelp" class="panel-collapse collapse" aria-expanded="false"
                           style="height: 0px;">
                        <div v-if="$root.$i18n.locale == 'en'" class="box-body">
                          <p>Here one can create items of «Frequently Asked Questions» for the Sports Organisation as a whole. It means that the F.A.Q. items added in this section will be applicable to all Sports Programs created by the Sports Organisation. Once the item is added, one may edit, publish/unpublish or delete it if needed.</p>
                          <p>There is always a possibility to add a specific F.A.Q. item for a single sports program in the relevant section «Sports Programs».</p>
                        </div>
                        <div v-if="$root.$i18n.locale == 'ru'" class="box-body">
                          <p>В этой секции можно создать список часто задаваемых вопросов (и соответствующих ответов) к Спортивной Организации в целом. Эти «вопросы» будут применимы ко всем Спортивным Программам, проводимым Спортивной Организацией. Добавленный «вопрос» можно отредактировать, опубликовать / снять с публикации, удалить в любой момент времени.</p>
                          <p>Всегда есть возможность добавить уникальный «вопрос» для той или иной спортивной программы в соответствующей секции Кабинета «Спортивные Программы».</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="box box-success">
                <div class="box-header">
                  <h3 class="box-title">{{$t('camps.faqs.subtitle')}}</h3>
                </div>
                <div class="box-body table-responsive no-padding">
                  <table
                    v-for="faq in faqs"
                    :key="faq.id"
                    class="table table-hover">
                    <tbody>
                    <tr v-if="!isBackoffice()">
                      <th width="25%">{{$t('trainings.faqs.question')}}</th>
                      <th>{{$t('trainings.faqs.answer')}}</th>
                      <th width="15%"></th>
                      <th width="10%" rowspan="4">
                        <button type="submit" v-on:click="updateFaq(faq)" class="btn btn-info pull-right">
                          {{$t('button.save-changes')}}
                        </button>
                      </th>
                      <th width="5%" rowspan="4"><a v-on:click="deleteFaq(faq.id)"><i class="text-red fa fa-times-circle-o"></i></a></th>
                    </tr>

                    <tr v-if="!isBackoffice()">
                      <td><input type="text" v-model="faq.question[$root.$i18n.locale]" class="form-control" placeholder=""></td>
                      <td><textarea style="height: 150px;" v-model="faq.answer[$root.$i18n.locale]" class="form-control"></textarea></td>
                      <td rowspan="3">
                        <label>
                          <input type="checkbox" :value="faq.isPublish" name="isPublish" v-model="faq.isPublish">
                          {{ $t('trainings.faqs.is-publish') }}
                        </label>
                      </td>
                    </tr>

                    <tr v-if="isBackoffice()">
                      <th width="25%">{{$t('trainings.faqs.question')}} [en]</th>
                      <th>{{$t('trainings.faqs.answer')}} [en]</th>
                      <th width="15%"></th>
                      <th width="10%" rowspan="4">
                        <button type="submit" v-on:click="updateFaq(faq)" class="btn btn-info pull-right">
                          {{$t('button.save-changes')}}
                        </button>
                      </th>
                      <th width="5%" rowspan="4"><a v-on:click="deleteFaq(faq.id)"><i class="text-red fa fa-times-circle-o"></i></a></th>
                    </tr>

                    <tr v-if="isBackoffice()">
                      <td><input type="text" v-model="faq.question['en']" class="form-control" placeholder=""></td>
                      <td><textarea style="height: 150px;" v-model="faq.answer['en']" class="form-control"></textarea></td>
                      <td rowspan="3">
                        <label>
                          <input type="checkbox" :value="faq.isPublish" name="isPublish" v-model="faq.isPublish">
                          {{ $t('trainings.faqs.is-publish') }}
                        </label>
                      </td>
                    </tr>

                    <tr v-if="isBackoffice()">
                      <th>{{$t('trainings.faqs.question')}} [ru]</th>
                      <th>{{$t('trainings.faqs.answer')}} [ru]</th>

                    </tr>

                    <tr v-if="isBackoffice()">
                      <td><input type="text" v-model="faq.question['ru']" class="form-control" placeholder=""></td>
                      <td><textarea style="height: 150px;" v-model="faq.answer['ru']" class="form-control"></textarea></td>
                    </tr>

                    </tbody>
                  </table>
                </div>
              </div>

              <div class="box box-success">
                <div class="box-header">
                  <h3 class="box-title">{{$t('camps.faqs.added-form.title')}}</h3>
                </div>
                <div class="box-body">
                  <div v-if="!isBackoffice()" class="form-group">
                    <label>{{$t('trainings.faqs.added-form.question')}}</label>
                    <input type="text" v-model="addedFaq.question[$root.$i18n.locale]" class="form-control"
                           placeholder="">
                  </div>
                  <div v-if="isBackoffice()" class="form-group">
                    <label>{{$t('trainings.faqs.added-form.question')}} [en]</label>
                    <input type="text" v-model="addedFaq.question['en']" class="form-control"
                           placeholder="">
                  </div>
                  <div v-if="isBackoffice()" class="form-group">
                    <label>{{$t('trainings.faqs.added-form.question')}} [ru]</label>
                    <input type="text" v-model="addedFaq.question['ru']" class="form-control"
                           placeholder="">
                  </div>

                  <div v-if="!isBackoffice()" class="form-group">
                    <label>{{$t('trainings.faqs.added-form.answer')}}</label>
                    <textarea style="height: 300px;" v-model="addedFaq.answer[$root.$i18n.locale]" class="form-control"></textarea>
                  </div>
                  <div v-if="isBackoffice()" class="form-group">
                    <label>{{$t('trainings.faqs.added-form.answer')}} [en]</label>
                    <textarea style="height: 300px;" v-model="addedFaq.answer['en']" class="form-control"></textarea>
                  </div>
                  <div v-if="isBackoffice()" class="form-group">
                    <label>{{$t('trainings.faqs.added-form.answer')}} [ru]</label>
                    <textarea style="height: 300px;" v-model="addedFaq.answer['ru']" class="form-control"></textarea>
                  </div>

                  <div class="form-group">
                    <label>
                      <input type="checkbox" :value="addedFaq.isPublish"
                             name="isPublish" v-model="addedFaq.isPublish">
                      {{ $t('trainings.faqs.is-publish') }}
                    </label>
                  </div>
                </div>
                <div class="box-footer">
                  <button type="submit" v-on:click="addFaq" class="btn btn-info pull-right">
                    {{$t('button.save-changes')}}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default pull-left" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'CampFaqs',
  data () {
    return {
      campId: '',
      addedFaq: {
        question: {
          ru: '',
          en: ''
        },
        answer: {
          ru: '',
          en: ''
        },
        isPublish: false
      },
      faqs: []
    };
  },
  created () {
    let self = this;

    self.$root.$on('showCampFaqs', function (campId) {
      self.campId = campId;

      axios.get(window.host + '/sport-courses/camps/' + campId + '/faqs')
        .then(function (response) {
          console.log(response.data);
          self.faqs = response.data;
        })
        .catch(function () {
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    });
  },
  methods: {
    isBackoffice: function () {
      return window.application !== 'cabinet';
    },
    addFaq: function () {
      let self = this;

      // const AuthStr = 'Bearer ' + JSON.parse(localStorage.getItem('user')).token;

      let data = {
        question: self.addedFaq.question,
        answer: self.addedFaq.answer,
        isPublish: self.addedFaq.isPublish
      };

      axios.post(window.host + '/sport-courses/camps/' + self.campId + '/faqs', data)
        .then(function (response) {
          console.log(response.data);
          self.$root.$emit('alert', 'success', 'alert.success');
          self.$root.$emit('showCampFaqs', self.campId);
        })
        .catch(function () {
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    },
    updateFaq: function (faq) {
      let self = this;

      // const AuthStr = 'Bearer ' + JSON.parse(localStorage.getItem('user')).token;

      let data = {
        question: faq.question,
        answer: faq.answer,
        isPublish: faq.isPublish
      };

      axios.put(window.host + '/sport-courses/camps/' + self.campId + '/faqs/' + faq.id, data)
        .then(function (response) {
          console.log(response.data);
          self.$root.$emit('alert', 'success', 'alert.success');
          self.$root.$emit('showCampFaqs', self.campId);
        })
        .catch(function () {
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    },
    deleteFaq: function (faqId) {
      let self = this;

      // const AuthStr = 'Bearer ' + JSON.parse(localStorage.getItem('user')).token;

      axios.delete(window.host + '/sport-courses/camps/' + self.campId + '/faqs/' + faqId)
        .then(function (response) {
          console.log(response.data);
          self.$root.$emit('alert', 'success', 'alert.success');
          self.$root.$emit('showCampFaqs', self.campId);
        })
        .catch(function () {
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    }
  }
};
</script>

<style scoped>
  .modal-dialog-l {
    width: 80%;
  }
</style>
